import {
    Box,
    ToggleButton,
    ToggleButtonGroup,
    Zoom,
    IconButton
} from "@mui/material";
import {
    DarkMode as DarkModeIcon,
    LightMode as LightModeIcon,
} from "@mui/icons-material";
import { ThemeProvider, createTheme, useColorScheme } from '@mui/material/styles';


function ThemeToggle({ mode, setMode }) {
    // const { mode, setMode } = useColorScheme();
    if (!mode) return null;

    return (
        <Box

        >
            <IconButton
                size="small"
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: "background.primary",
                    color: "text.primary",
                    borderRadius: 0,
                }} onClick={() => setMode(mode === "light" ? "dark" : "light")}>
                {mode === "light" ? <DarkModeIcon /> : <LightModeIcon />}
            </IconButton>
        </Box >
    );
}

export default ThemeToggle;
